'use strict';

var isPrimitive = require('./isPrimitive');

function hasProperty(obj, prop) {
  return !isPrimitive(obj) && prop in obj;
}

module.exports = hasProperty;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/hasProperty.js
// module id = 451
// module chunks = 0